import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';

import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/system';
import { TailSpin } from 'react-loader-spinner';

import { BookmarkPage } from './BookmarkPage';

export const BookmarkPageContainer = () => {
  const completedNuggetIds = useAppSelector((state) => state.user.user?.completed_nugget_ids);
  const bookmarks = useAppSelector((state) => state.user.user?.bookmarks);

  const { loading: nuggetsLoading } = useAppSelector((state) => state.contentNugget);

  if (nuggetsLoading) {
    return (
      <Box sx={loadingSpinnerStyle}>
        <TailSpin color="#000" height={50} width={50} />
      </Box>
    );
  }

  return <BookmarkPage completedNuggetIds={completedNuggetIds} bookmarks={bookmarks} />;
};

const loadingSpinnerStyle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
};
